'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../index-4ac15ccc.js');
require('../../lib-75591456.js');
require('tslib');
require('../../icon-e3ab87ed.js');
require('react');
require('classnames');
require('styled-components');
require('@prisjakt/design-tokens/light-theme-colors');



exports.IconInfoOutlined = index.IconInfoOutlined;
//# sourceMappingURL=index.js.map
